export default __webpack_public_path__ + "static/media/arrow-title-mobile.3a31d63b.svg";